import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import LakeStatsSection from './components/LakeStatsSection';
import SignupSection from './components/SignupSection';
import FooterSection from './components/FooterSection';

export default function HomePage() {
  return (
    <main className="w-full min-h-screen overflow-x-hidden">
      <HeroSection />
      <AboutSection />
      <LakeStatsSection />
      <SignupSection />
      <FooterSection />
    </main>
  );
}
